import { DOCUMENT } from '@angular/common';
import {
    Directive,
    ElementRef,
    HostListener,
    Inject,
    OnInit,
    Renderer2,
} from '@angular/core';

@Directive({
    selector: '[appScrollProgress]',
})
export class ScrollProgressDirective implements OnInit {
    private progressBar: any;
    private scrollSection: any;
    private scrollThrottleTimeout: any;
    private lastScrollPosition: number;

    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        @Inject(DOCUMENT) private document: Document
    ) {}

    ngOnInit(): void {
        this.createProgressBar();
        this.scrollSection = this.document.getElementById(
            'scrollProgressContainer'
        );
    }

    @HostListener('window:scroll', [])
    onScroll(): void {
        if (!this.scrollThrottleTimeout) {
            this.scrollThrottleTimeout = setTimeout(() => {
                this.updateProgressBar();
                this.scrollThrottleTimeout = null;
            }, 50);

            const isScrollingDown =
                window.scrollY > (this.lastScrollPosition || 0);

            if (isScrollingDown) {
                this.renderer.removeClass(this.el.nativeElement, 'scroll-up');
            } else {
                this.renderer.addClass(this.el.nativeElement, 'scroll-up');
            }

            this.lastScrollPosition = window.scrollY;
        }
    }

    private createProgressBar(): void {
        this.progressBar = this.renderer.createElement('div');
        this.renderer.addClass(this.progressBar, 'progress-bar');

        // Add a class to the host element for styling
        this.renderer.addClass(this.el.nativeElement, 'progress-container');
        this.renderer.appendChild(this.el.nativeElement, this.progressBar);
    }

    private updateProgressBar(): void {
        const scrollPosition = window.scrollY;
        const specificSectionHeight = this.scrollSection.clientHeight;
        const totalHeight = specificSectionHeight - window.innerHeight;

        // Ensure we don't go beyond the specific section's height
        const progress = Math.round((scrollPosition / totalHeight) * 100);

        this.renderer.setStyle(this.progressBar, 'width', `${progress}%`);
    }
}
